import {CommonModule}                                              from '@angular/common';
import {booleanAttribute, Component, ElementRef, input, ViewChild} from '@angular/core';
import {ChartConfiguration}                                        from 'chart.js';
import {ChartCompBase}                                             from '../../tools/chart-comp.base';


@Component({
			   selector   : 'lib-chart-line',
			   imports    : [CommonModule],
			   templateUrl: './chart-line.component.html',
			   styleUrl: './chart-line.component.css'
		   })
export class ChartLineComponent extends ChartCompBase<'line', any> {
	@ViewChild('ChartItem') chartItem!: ElementRef<HTMLCanvasElement>;
	@ViewChild('LegendWrapper') legendWrapper!: ElementRef<HTMLDivElement>;
	chartConf = input.required<ChartConfiguration<'line'>>();
	disableLegend = input(booleanAttribute(false), {transform: booleanAttribute});
}
